// import React, { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination, Autoplay, EffectCoverflow } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/effect-coverflow";
// import "./TrendingSection.css"; // Import CSS

// const TrendingSection = ({ alumniData, eventData }) => {
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [currentCardIndex, setCurrentCardIndex] = useState(0);

//   return (
//     <section className="trending-section">
//       <h2>Trending @ Alumni Relations Committee</h2>

//       {/* Flex container (Stack on smaller screens) */}
//       <div className="trending-container">

//         {/* Left Section (Swiper) */}
//         <div className="left-section">
//           <div className="slider-container">
//             <Swiper
//               modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
//               spaceBetween={80}
//               slidesPerView={1}
//               pagination={{ clickable: true }}
//               centeredSlides={true}
//               autoplay={{ delay: 2500, disableOnInteraction: false }}
//               loop={true}
//               className="event-swiper"
//             >
//               {alumniData.map((card, index) => (
//                 <SwiperSlide key={card.id}>
//                   <div
//                     className={`event-card ${index === currentCardIndex ? "active" : ""}`}
//                     onMouseEnter={() => setHoveredCard(card.id)}
//                     onMouseLeave={() => setHoveredCard(null)}
//                   >
//                     <img src={card.image} alt={card.name} />
//                     <h3>{card.designation}</h3>
//                   </div>
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           </div>
//         </div>

//         {/* Right Section (Grid) - Now Stacks on Small Screens */}
//         <div className={`page-container ${selectedEvent ? "blur-background" : ""}`}>
//           <div className="right-section">
//             {eventData.map((event, index) => (
//               <div
//                 key={index}
//                 className="grid-block"
//                 style={{ backgroundImage: `url(${event.images[0]})` }}
//                 onClick={() => setSelectedEvent(event)}
//               >
//                 <div className="grid-overlay"></div>
//                 <div className="grid-title">{event.title}</div>
//               </div>
//             ))}
//           </div>
//         </div>

//       </div>
//     </section>
//   );
// };

// export default TrendingSection;


import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import "./TrendingSection.css";
import { useNavigate } from 'react-router-dom';

const TrendingSection = ({ alumniData, eventData }) => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const navigate = useNavigate();

  const handleEventClick = (event) => {
    console.log("Navigating to:", `/pages/media-page`, "with event:", event.title);
    navigate('/pages/media-page', { 
      state: { 
        selectedEvent: event.title
      } 
    });
  };

  return (
      <section className="trending-section">
      <h2>Trending @ Alumni Relations Committee</h2>

      <div className="trending-container">
        <div className="left-section">
          <div className="slider-container">
            <Swiper
              modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
              spaceBetween={80}
              slidesPerView={1}
              pagination={{ clickable: true }}
              centeredSlides={true}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              loop={true}
              className="event-swiper"
            >
              {alumniData.map((card, index) => (
                <SwiperSlide key={card.id}>
                  <div
                    className={`event-card ${index === currentCardIndex ? "active" : ""}`}
                    onMouseEnter={() => setHoveredCard(card.id)}
                    onMouseLeave={() => setHoveredCard(null)}
                  >
                    <img src={card.image} alt={card.name} />
                    <h3>{card.designation}</h3>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        <div className="page-container">
          <div className="right-section">
            {eventData.map((event, index) => (
              <div
                key={index}
                className="grid-block"
                style={{ backgroundImage: `url(${event.images[0]})` }}
                onClick={() => handleEventClick(event)}
              >
                <div className="grid-overlay"></div>
                <div className="grid-title">{event.title}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrendingSection;